// 一位小数正则
export const matchFractionalPart1 = /^\d+(\.[0-9]{1})?$/g
// 两位小数正则
export const matchFractionalPart2 = /^\d+(\.[0-9]{1,2})?$/g
// 正整数 + 0
export const matchInteger = /^\+?[0-9]*$/
// 银行卡正则
export const matchBankCard = /^(?:62|88|99|19\d{2}|4\d{3}|5[1-5]\d{2}|6\d{3}|81\d{2})\d{10}|^62\d{12,17}|^[0-9]{16,19}$/
// 手机号
export const matchMobile = /^1\d{10}$/
// 正整数
export const matchIntegerNew = /^\+?[1-9]\d*$/
// 正负数并可保留一位小数
export const matchNegativePart1 = /^-?\d+(\.[0-9]{1})?$/g
// 整数+2位小数
export const matchNegativePart2 = /^-?(0|[1-9]\d*)(\.\d{1,2})?$/
// 整数+1位小数
export const matchNegativePart3 = /^-?(0|[1-9]\d*)(\.\d{1})?$/
export const urlReg = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;

// 两位小数
export const formatDecimalInput = (value) => {
  return value
  .replace(/[^\d.]/g, '') // 非数字和小数点去除
  .replace(/^(\d*\.\d{0,2}).*$/, '$1') // 限制最多两位小数
  .replace(/^0+(\d)/, '$1') // 去前导 0（保留一个）
  .replace(/^\./, '') // 不允许首字符是小数点
  .replace(/(\..*)\./g, '$1'); // 禁止多个小数点
};

export const formatPositiveIntegerInput = (value) => {
  return value
  .replace(/[^\d]/g, '')         // 去除非数字字符
  .replace(/^0+/, '')            // 去除前导0（全删）
};






// WEBPACK FOOTER //
// ./src/utils/regExp.js